
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/security-wait",
      function () {
        return require("private-next-pages/security-wait/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/security-wait"])
      });
    }
  